/**
 * tdesign v1.6.6
 * (c) 2023 tdesign
 * @license MIT
 */

import './useConfig.js';
import { useConfig } from '../config-provider/useConfig.js';
import '@vue/composition-api';
import '../config-provider/context.js';
import 'lodash/merge';
import 'lodash/mergeWith';
import '../_common/js/global-config/default-config.js';
import '../_common/js/global-config/locale/zh_CN.js';
import '@babel/runtime/helpers/typeof';
import '../_chunks/dep-fdafdce0.js';
import 'dayjs';
import '../_chunks/dep-9849f16c.js';
import '../config-provider/type.js';

function useGlobalIcon(tdIcon) {
  var _useConfig = useConfig("icon"),
    global = _useConfig.global;
  var resultIcon = {};
  Object.keys(tdIcon).forEach(function (key) {
    var _global$value;
    resultIcon[key] = ((_global$value = global.value) === null || _global$value === void 0 ? void 0 : _global$value[key]) || tdIcon[key];
  });
  return resultIcon;
}

export { useGlobalIcon as default, useGlobalIcon };
//# sourceMappingURL=useGlobalIcon.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/tdesign-vue/es/hooks/useGlobalIcon.js
// module id = null
// module chunks = 